import SwitcherContainer from '../../../components/atoms/container/switcherContainer';
import SwitcherBall from '../../../components/atoms/container/switcherBall';
import useTransform from '../../../../shared/components/utils/hooks/useTransform';
import Direction from '../../../../shared/types/enums/direction';
import Focus from '../../../../shared/types/enums/focus';
import useKeyboard from '../../../../shared/components/utils/hooks/useKeyboard';
import { useEffect, useRef } from 'react';
import { useAppDispatch } from '../../../../shared/store/hooks';
import { setFocus } from '../../../../shared/store/slices/focus.slice';
import Storage from '@storage';

const SWITCH_OFFSET = -107;

function Switcher({ active }: { active: boolean }) {
  const dispatch = useAppDispatch();
  const activeReference = useRef(active ? true : false);
  const [style, change] = useTransform(
    active ? 1 : 0,
    SWITCH_OFFSET,
    Direction.HORIZONTAL
  );

  useEffect(() => {
    dispatch(setFocus(Focus.SWITCHER));
  }, []);
  useKeyboard({
    focus: Focus.SWITCHER,
    keyDownHandler(key) {
      if (key === 'SELECT') {
        activeReference.current = !activeReference.current;
        change(activeReference.current ? 1 : -1);
        Storage.set('deadmanActive', activeReference.current ? '1' : '0');
      }
    },
  });
  return (
    <SwitcherContainer id={'switcherContainer'}>
      <SwitcherBall
        style={style}
        active={activeReference.current}
      ></SwitcherBall>
    </SwitcherContainer>
  );
}

export default Switcher;
